import React from 'react'
import Fade from '@mui/material/Fade'
import Box from '@mui/material/Box'

import AuthorizedHeader from '../../components/authorized-header'
import Translate from '../../components/translate'
import StyledContainer from '../../components/styled-container'
import * as Headline from '../../components/headline'

import GeneralSettings from './general-settings'
import { reducer, initialState, StoreContext } from './store'

const SettingsBody: React.FC = React.memo(function SettingsBody() {
    return (
        <Box
            component='div'
            data-testid='settings'
            sx={{
                backgroundColor: (theme) => theme.palette.background.default,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <AuthorizedHeader />
            <Fade in={true}>
                <StyledContainer maxWidth={false}>
                    <Headline.Component
                        title={<Translate>SETTINGS</Translate>}
                    />
                    <GeneralSettings />
                </StyledContainer>
            </Fade>
        </Box>
    )
})

const Settings: React.FC = React.memo(function Settings() {
    const [state, dispatch] = React.useReducer(reducer, initialState)
    const store = React.useMemo(() => ({ state, dispatch }), [state, dispatch])

    return (
        <StoreContext.Provider value={store}>
            <SettingsBody />
        </StoreContext.Provider>
    )
})

export default Settings
